module.exports = __webpack_public_path__ + "static/media/popup-google.1bc4cb73.png";